<template lang="pug">
    .eventsMobileSlider(ref="eventsMobileSlider")
        .prev(@click="$emit('slideChange', prevEvent)" v-html="$t('event.prevEvent')")
        .swiper-container
            .swiper-wrapper
                .swiper-slide(v-for="event in events")
                    .bullit(@click="$emit('slideChange', event)")
        .next( @click="$emit('slideChange', nextEvent)" v-html="$t('event.nextEvent')")
</template>

<script>
    export default {
        name: "EventsMobileSlider",
        props:['events', 'prevEvent', 'nextEvent', 'activeSlide'],
        data: ()=>({
            slider: null,
        }),
        mounted() {
            new Swiper(this.$refs.eventsMobileSlider.querySelector('.swiper-container'), {
                grabCursor: true,
                initialSlide: this.activeSlide,
                centeredSlides: true,
                slidesPerView: 7,
                slideActiveClass: 'active',
                slideToClickedSlide: true,
                simulateTouch: false,
                allowTouchMove: false,
                navigation: {
                    prevEl: this.$refs.eventsMobileSlider.querySelector('.prev'),
                    nextEl: this.$refs.eventsMobileSlider.querySelector('.next'),
                },
            })
        }
    }
</script>

<style scoped lang="scss">
    .eventsMobileSlider{
        width: calc(100% - 5.5rem);
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.disabled{
            pointer-events: none;
        }
    }
    .prev, .next{
        display: flex;
        align-items: center;
        color: #000;
        transition: opacity .2s;
        &.swiper-button-disabled{
            opacity: 0.3;
            pointer-events: none;
        }
    }
    .next{
        text-align: right;
    }
    .prev:before, .next:after{
        content: '';
        display: block;
        width: 1.7rem;
        height: 1.5rem;
        background: url(../../assets/img/arrow_black.png) no-repeat center center / contain;
    }
    .prev:before{
        margin-right: 0.5rem;
        transform: scale(-1, 1);
    }
    .next:after{
        margin-left: 0.5rem;
    }
    .swiper-container{
        width: 100%;
        max-width: 8rem;
        &:after{
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 2;
            background: linear-gradient(to right, rgba(#fff, 0.8) 0%, rgba(#fff, 0) 35%, rgba(#fff, 0) 65%, rgba(#fff, 0.8) 100%);
            pointer-events: none;
        }
        .swiper-slide{
            .bullit{
                width: 0.7rem;
                height: 0.7rem;
                margin: 0 0.2rem;
                border-radius: 50%;
                background: #d7d7d7;
            }
            &.active .bullit{
                background: $red;
            }
        }
    }
    /*.pagination{
        max-width: 8rem;
        display: flex;
        justify-content: space-around;
        .bullit{
            width: 0.7rem;
            height: 0.7rem;
            margin: 0 0.2rem;
            border-radius: 50%;
            background: #d7d7d7;
            &.active{
                background: $red;
            }
        }
    }*/
</style>
